import React from "react";

function ContactCard() {
  return (
    <div
      className="contact-card-container"
      style={{
        background: "#f5f6fa",
        borderRadius: "32px",
        width: "600px",
        maxWidth: "97vw",
        padding: "38px 42px 32px 42px",
        boxShadow: "0 4px 28px rgba(60,62,115,0.16)",
        margin: "0 auto",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <div style={{ fontSize: "29px", fontWeight: 700, marginBottom: "16px" }}>
        Contacts
      </div>
      <div
        style={{
          position: "absolute",
          right: "40px",
          top: "38px",
          fontSize: "15px",
          color: "#3535b7",
          opacity: 0.76,
          fontWeight: 500,
          letterSpacing: "0.6px",
        }}
      >
        @matvibhor24
      </div>
      <div
        style={{
          color: "#2584FF",
          fontSize: "17px",
          fontWeight: 500,
          marginBottom: "16px",
          cursor: "pointer",
          textDecoration: "none",
        }}
      >
        <a
          href="https://mailto:matvibhor24@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2584FF", textDecoration: "none" }}
        >
          matvibhor24@gmail.com{" "}
          <span style={{ fontSize: "16px", marginLeft: "6px" }}>➔</span>
        </a>
      </div>
      <div
        style={{
          display: "flex",
          gap: "24px",
          marginBottom: "8px",
          fontSize: "14px",
          marginTop: "4px",
        }}
      >
        <a
          href="https://www.linkedin.com/in/vibhor-mathur-5006141b0/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#23232f", cursor: "pointer" }}
        >
          LinkedIn
        </a>
        <a
          href="https://www.instagram.com/matvibhor/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#23232f", cursor: "pointer" }}
        >
          Instagram
        </a>
        <a
          href="https://github.com/Matvibhor24"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#23232f", cursor: "pointer" }}
        >
          Github
        </a>
        <a
          href="https://x.com/matvibhor24?t=i46cHfl28UeS-RhKFoGKTw&s=09"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#23232f", cursor: "pointer" }}
        >
          X
        </a>
      </div>

      <div
        style={{
          width: "99%",
          fontSize: "15px",
          color: "#23234c",
          marginTop: "18px",
        }}
      >
        <div style={{ marginBottom: "12px" }}>
          Awesome! You can hit me up directly at{" "}
          <a
            href="mailto:matvibhor24@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#2584FF",
              textDecoration: "none",
              fontWeight: 500,
            }}
          >
            matvibhor24@gmail.com
          </a>{" "}
          or connect with me on{" "}
          <a
            href="https://www.linkedin.com/in/vibhor-mathur-5006141b0/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#2584FF",
              textDecoration: "none",
              fontWeight: 500,
            }}
          >
            LinkedIn.
          </a>
        </div>
        <div>
          Always happy to chat about AI, startups or just new Tech! What's on
          your mind?
        </div>
      </div>
    </div>
  );
}

export default ContactCard;
